import * as actionTypes from "./actionTypes";
import * as wingetsService from "./service";

const log = require("loglevel").getLogger("WidgetsActions");
log.setLevel("error");

export const loadWidget = (name) => {
  return async (dispatch) => {
    log.debug("WidgetsActions -> loadWidget -> Enter");
    await dispatch({
      type: actionTypes.UPDATE_WIDGET_STATUS,
      name,
      status: "loading",
    });

    const result = await wingetsService.loadWidgetByName(name);

    await dispatch({
      type: actionTypes.UPDATE_WIDGET_STATUS,
      name,
      data: result,
      status: "loaded",
    });
  };
};
